import store from "@/store/store.js";

// Route-level feature-flag gate. Mirrors the featureUnlockedChecker mixin
// (isFeatureVisible / isFeatureUnlocked) but usable in router guards, which
// run outside component context.
//
// Returns true when the feature's route may be entered:
//   - config not loaded / not logged in  -> true (auth guards handle it)
//   - no flag configured for the feature -> true (backwards compatible)
//   - otherwise the user's level must meet BOTH the `visible` and `unlocked`
//     levels from generalConfig.settings["feature.flags"][feature].
export function isFeatureRouteAllowed(feature) {
  const config = store.getters["getGeneralConfig"];
  if (!config || !store.getters["auth/isLoggedIn"]) return true;

  const flags = config.settings && config.settings["feature.flags"];
  const flag = flags && flags[feature];
  if (!flag) return true;

  const level = parseInt(store.getters["user/currentUser"].level, 10) || 0;
  const visibleLevel = flag.visible != null ? flag.visible : 1;
  const unlockedLevel = flag.unlocked != null ? flag.unlocked : 1;
  return level >= visibleLevel && level >= unlockedLevel;
}
